import { before } from 'lodash-es';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default defineNuxtPlugin(() => {
  return {
    provide: {
      rules: {
        required: (v: any) => (v !== null && v !== undefined && v !== '') || '必須項目です',
        notEmpty: (v: any[]) => v.length > 0 || '必須項目です',
        max: (max: number, v: any) => {
          return v <= max || `${max} より小さい値を設定してください`;
        },
        min: (min: number, v: any) => {
          return v >= min || `${min} より大きい値を設定してください`;
        },
        maxTime: (max: string, v: any) => {
          return v <= max || `${max} より前の時間を設定してください`;
        },
        email: (v: any) => /.+@.+\..+/.test(v) || 'メールアドレスを入力してください',
        password: (v: any) => /.{8,}/.test(v) || 'パスワードは8文字以上で入力してください',
        maxLength: (max: number, v: any) => v === undefined || v.length <= max || `${max} 文字以内で入力してください`,
        number: (v: any) => /^\d+$/.test(v) || '数字で入力してください',
        confirmPassword: (v1: string, v2: string) => v1 === v2 || 'パスワードが一致しません',
        ipv4: (v: any) =>
          /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/.test(
            v,
          ) || '有効なIPアドレスを入力してください',
        equal: (v1: string, v2: string) => v1 === v2 || '入力した値が一致しません',
        dateBefore: (date: string, v: string) => {
          if (!date) return true; // If no date is provided, skip validation
          const inputDate = new Date(v);
          const compareDate = new Date(date);
          return inputDate < compareDate || `${date}より前の日付を設定してください`;
        },
        dateAfter: (date: string, v: string) => {
          if (!date) return true; // If no date is provided, skip validation
          const inputDate = new Date(v);
          const compareDate = new Date(date);
          return inputDate > compareDate || `${date}より後の日付を設定してください`;
        },
      },
    },
  };
});
